import React from 'react';
import Localization from '../Localization';

export default function Introduction(props) {
  const { setShow } = props;

  return (
    <div>
      <div className='content'>
        {Localization.get('introText')}
      </div>
      <div className='button' onClick={() => setShow(false)}>
        <button>
          {Localization.get('Explore')}
        </button>
      </div>
    </div>
  );
}